import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background-50 px-4 text-center">
      <span className="text-8xl md:text-[10rem] font-heading font-bold text-primary-200 select-none leading-none">
        404
      </span>
      <h1 className="mt-6 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
        {t("notFound.title")}
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500">{t("notFound.desc")}</p>
      <Link
        to="/"
        className="mt-7 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
      >
        {t("button.backHome")}
        <i className="ri-arrow-left-line"></i>
      </Link>
    </div>
  );
}